import { combineReducers } from 'redux';

import consultarLocalidadesAssociada from './consultarLocalidadesAssociada/reducer';

export default combineReducers({
	consultarLocalidadesAssociada,
});
